import { PublicLayout } from '../components/Layout/PublicLayout'
import { JottaTermsAndConditions } from '../components/JottaTermsAndConditions'
import { useBrandCode } from '@jotta/ui/useBrandTheme'
import { useGetConfig } from '@jotta/grpc-connect-client/config'
import { Redirect } from '@jotta/ui/Redirect'
import { LoadingOverlay } from '@jotta/ui/LoadingOverlay'

export function TermsRoute() {
  const isJotta = useBrandCode() === 'JOTTACLOUD'

  const { data: getConfigResponse } = useGetConfig()
  const brandingInfo = getConfigResponse?.brandingInfo
  const termsLink = brandingInfo?.termsLink

  if (isJotta) {
    return (
      <PublicLayout section="terms">
        <JottaTermsAndConditions className="mx-auto max-w-6xl" />
      </PublicLayout>
    )
  }

  return termsLink ? <Redirect to={termsLink} /> : <LoadingOverlay open />
}
